import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { OrganizationData } from '@/types/organization';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

interface RequestParams {
  name: string;
}

type Response = OrganizationData[];

const validate = (name: string) => {
  if (!name) {
    throw new Error('Organization name is required');
  }
};

export const getOrganizationByName = async (
  scope: RequestScope,
  { name }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(name);

    const query = encodeURIComponent(JSON.stringify({ name }));
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`organization?query=${query}`, options);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
